import { useContext } from 'react';
import { AutomatonTagsContext } from '../contexts';

export const useAutomatonTagsContext = () => useContext(AutomatonTagsContext);
